import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { RecommendationService } from 'src/app/questionarie-signup/questionnaire-residential/recommendation/recommendation.service';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-deposit-pending',
  templateUrl: './deposit-pending-status.component.html',
  styleUrls: ['./deposit-pending-status.component.css'],
})
export class DepositPendingStatus implements OnInit {
  status: string;
  enrollNotifyObj: any;
  url = environment.api_url;
  providerContact: any;
  hgAccountID: string;
  queryObj = {
    _id: '',
    esiid: '',
    hg_orders_id: '',
    hg_accountId: '',
  };
  updateObj = {
    processCompleted: '',
    showNotification: '',
    type: '',
  };
  notifyMessages = {
    Complete:
      'CONGRATULATIONS! You have successfully enrolled for a new energy plan. We greatly appreciate your business!',
    Failed: '',
  };
  confirmationNumber: any;
  selectedProduct: any;

  constructor(
    private router: Router,
    private http: HttpClient,
    private residentialService: ResidentialService,
    private recommendationService: RecommendationService
  ) {}

  ngOnInit() {
    this.status = window.location.href.split('/').pop();
    this.status = this.status === 'Complete' ? 'Completed' : this.status;
    this.hgAccountID = JSON.parse(sessionStorage.getItem('userObj'))._id;
    const result = JSON.parse(sessionStorage.getItem('userObj'));
    this.selectedProduct = JSON.parse(sessionStorage.getItem('signupProduct'));
    this.postPulsePowerOrderDetails();
  }

  // postPulsePowerOrderDetails() {
  //   const orderDetails: any = {
  //     status: this.status,
  //     webStatus: this.status,
  //   };
  //   const order = JSON.parse(sessionStorage.getItem('orderDetails'));
  //   this.confirmationNumber = orderDetails.ConfirmationNumber;
  //   const body = new HttpParams()
  //     .append('hg_accountId', order.hg_accountId)
  //     .append('orderId', order.order_no)
  //     .append('orderDetails', orderDetails);
  //   this.http
  //     .post(this.url + '/updateOrderStatusDetails', body)
  //     .subscribe((res: any) => {
  //       const result = res;
  //       this.sendCongratsMail();
  //       this.router.navigate(['congrats', this.hgAccountID]);
  //     });
  //   sessionStorage.removeItem('orderDetails');
  // }

  postPulsePowerOrderDetails() {
    const orderDetails: any = JSON.parse(
      sessionStorage.getItem('orderDetails')
    );
    orderDetails.status = this.status;
    orderDetails.webStatus = this.status;
    this.confirmationNumber = orderDetails.ConfirmationNumber;

    const body = new HttpParams().append(
      'orderDetails',
      JSON.stringify(orderDetails)
    );
    this.http.post(this.url + '/saveorders', body).subscribe((res: any) => {
      const result = res;
      this.sendCongratsMail();
      this.router.navigate(['congrats', this.hgAccountID]);
    });
    sessionStorage.removeItem('orderDetails');
  }

  getProviderInfo() {
    this.residentialService
      .getProviderContactInfoDetails(
        this.selectedProduct.energy_provider,
        this.selectedProduct.utility_name
      )
      .subscribe((res: any) => {
        this.providerContact = res[0];
      });
  }
  sendCongratsMail() {
    const userObj = {
      hg_accountId: this.hgAccountID,
      ConfirmationNumber: this.confirmationNumber,
      emailId: JSON.parse(sessionStorage.getItem('userObj')).emailId,
    };
    const body = new HttpParams()
      .append('userDetails', JSON.stringify(userObj))
      .append(
        'providerContact',
        JSON.stringify(sessionStorage.getItem('energy_provider'))
      );
    this.http.post(this.url + '/congratsEmail', body).subscribe((res: any) => {
      const result = res;
    });
    sessionStorage.removeItem('userObj');
    sessionStorage.removeItem('energy_provider');
  }

  updateNotifications() {
    return {
      buttonName: '',
      buttonUrl: '',
      createdBy: '0',
      esiid: localStorage.getItem('currentEsiid'),
      isRead: false,
      lastUpdatedBy: '0',
      lastUpdatedDate: this.getServiceTypeDateObj(),
      message: this.notifyMessages[this.status],
      navigation_link: null,
      processCompleted: true,
      questionnairePercent: '0',
      showNotification: true,
      title: '',
      type: 'Enrollment_Completed',
      percentage: '0',
    };
  }

  updateNotificationObj(id) {
    if (this.status === 'Complete') {
      this.queryObj._id = '';
      this.queryObj.esiid = localStorage.getItem('currentEsiid');
      this.queryObj.hg_accountId = this.hgAccountID;
      this.queryObj.hg_orders_id = '';
      const enrollbody = new HttpParams()
        .append('queryObj', JSON.stringify(this.queryObj))
        .append('updateObj', JSON.stringify(this.updateNotifications()));

      this.http
        .post(this.url + '/updateNotification', enrollbody)
        .subscribe((res: any) => {
          const notifyresult = res;
          if (notifyresult.statusCode === '002') {
          } else {
            this.router.navigate(['congrats', id]);
          }
        });
    } else {
      this.router.navigate(['user-settings', id]);
    }
  }

  getServiceTypeDateObj() {
    const dateObj = new Date();
    return (
      [dateObj.getMonth() + 1, dateObj.getDate(), dateObj.getFullYear()].join(
        '/'
      ) +
      ' ' +
      [
        dateObj.getUTCHours(),
        dateObj.getUTCMinutes(),
        dateObj.getUTCSeconds(),
      ].join(':')
    );
  }
}
